import { useParams } from 'react-router-dom';
import { FilesModule } from '../modules/files';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function ScopeFilesPage(): JSX.Element {
  return (
    <StartupSubPageShell scopeSection="files">
      {({ startupId }) => <ScopeFiles startupId={startupId} />}
    </StartupSubPageShell>
  );
}

function ScopeFiles({ startupId }: { startupId: string }): JSX.Element | null {
  const { scopeId } = useParams<{ scopeId: string }>();
  if (!scopeId) return null;
  return <FilesModule owner={{ type: 'scope', startupId, scopeId }} />;
}
